import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Card, Typography, Box, Chip } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import { getAssigned } from 'src/api/teachers/my-infor';
import PlateTextField from 'src/components/widgets/plate-textfield'

export const AssignedOverview = () => {
  const hasFetched = useRef(false);
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const result = await getAssigned();
    setData(result);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Box component="main" sx={{ flexGrow: 1, py: 1, px: 0 }}>
      {data && data.length > 0 && (
        data.map((item, index) => (
          <Card key={index} sx={{ mb: 2, p: 1, boxShadow: 1 }}>
            <Grid container spacing={3}>
              <Grid xs={12} md={4}>
                <PlateTextField transmission={item.transmission} plate={item.plate} />
              </Grid>
              <Grid xs={12} md={4}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <ReadOnlyTextField label="ODO (Km)" value={item.lastKm} enumType="decimal" />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <ReadOnlyTextField label="Thương hiệu" value={item.brand} />
                  </Box>
                </Box> 
              </Grid>
              <Grid xs={12} md={4}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <ReadOnlyTextField label="Hiệu xe" value={item.name} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <ReadOnlyTextField label="Số xe" value={item.number} />
                  </Box>
                </Box> 
              </Grid>
              <Grid xs={12} md={12}>
                <Typography variant="subtitle2" gutterBottom 
                  sx={{ fontSize: '0.9rem', fontWeight: 'normal' }}>
                  Thông tin bảo dưỡng
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    gap: 1,
                    p: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    minHeight: '56px',
                    backgroundColor: 'background.paper',
                  }}
                >
                  {item.services.map((element, idx) => (
                    <Chip
                      key={idx}
                      label={
                        <Typography component="span" sx={{ fontSize: '0.95rem' }}>
                          {element.serviceName}:{' '}
                          <Typography
                            component="span"
                            sx={{ fontSize: '1.1rem' }}
                            color={element.color}
                          >
                            {element.value}
                          </Typography>
                        </Typography>
                      }
                      sx={{ maxWidth: '100%', py: 2.5, m: 0.5 }}
                    />
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Card>
         )) 
        )}
    </Box>
  );
};
